import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import '../Layout Sito/style.css';
import './styles/Top.css';
import FreeSolo2 from './FreeSolo2';
import Button from './Button'
// import Cookie from './Cookies';
import Navbar from './Navbar';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Paper from '@mui/material/Paper';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import Container from '@mui/material/Container';
import ButtonMui from '@mui/material/Button';
import ConnectionFinder from '../api/ConnectionFinder';
import Info from '../img/info.png';
import TextFStyle from './TextFStyle';
import Tooltip from '@mui/material/Tooltip';
import VisitCookie from './VisitCookie';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import SpeedIcon from '@mui/icons-material/Speed';
import LanIcon from '@mui/icons-material/Lan';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined';

const StyledCard = styled(Card)(({ theme }) => ({
    borderRadius: '20px',
    boxShadow: 'none',
    border: `1px solid ${theme.palette.grey[300]}`,
    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
    '&:hover': {
        transform: 'translateY(-10px)',
        boxShadow: '0 20px 40px -15px rgba(255, 15, 100, 0.25)',
    },
}));

function Home(props) {
    const [date, setDate] = useState();
    const [latestPosts, setLatestPosts] = useState([]);
    const [postsLoading, setPostsLoading] = useState(true);

    const filled = props.filled;
    const setFilled = props.f;
    useEffect(() => {
        window.scrollTo(0, 0);
        ConnectionFinder.get('/dbStatus').then((response) => {
            setDate(response.data.update)
        })
        ConnectionFinder.get('/posts')
            .then(res => {
                setLatestPosts((res.data.data || []).slice(0, 6));
                setPostsLoading(false);
            })
            .catch(err => {
                console.error("Errore recupero post:", err);
                setPostsLoading(false);
            });
        VisitCookie();
    }, [])
    return (
        <div className='Rcontex' style={{ width: '100%', overflowX: 'hidden' }}>
            <Navbar />
            <Box sx={{ py: { xs: 4, md: 8 }, px: { xs: 2, md: 4 }, mb: { xs: 4, md: 6 } }}>
                <Container maxWidth="lg">
                    <Box sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        gap: 4,
                        alignItems: { xs: 'center', md: 'stretch' },
                        justifyContent: 'center'
                    }}>
                        {/* Search Card */}
                        <Box sx={{ width: '100%', maxWidth: '460px', display: 'flex' }}>
                            <Paper
                                elevation={0}
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    p: { xs: 3, sm: 4 },
                                    borderRadius: '24px',
                                    boxShadow: '0 16px 40px rgba(0,0,0,0.07)',
                                    boxSizing: 'border-box',
                                }}
                            >
                                <Typography variant="h4" component="h1" sx={{ fontSize: { xs: '1.75rem', md: '2rem' }, fontWeight: 700, color: '#2c3e50', mb: 3, textAlign: 'center' }}>
                                    Ricerca Copertura
                                </Typography>
                                <Box component="form" method="post" sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, width: '100%', flexGrow: 1, justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 3, flexGrow: 1, justifyContent: 'space-evenly' }}>
                                        <FreeSolo2 label="Comune" filled={filled} classes={TextFStyle()} value={""} />
                                        <FreeSolo2 label="Indirizzo" filled={filled} classes={TextFStyle()} value={""} />
                                        <FreeSolo2 label="Civico" classes={TextFStyle()} value={""} />
                                    </Box>
                                    <Box sx={{ width: '100%', pt: 1 }}>
                                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                            <Button f={() => setFilled()} filled={filled} />
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', pt: 1.5, flexWrap: 'wrap' }}>
                                            <Typography sx={{ color: "text.secondary", fontSize: '13px' }}>
                                                Dati aggiornati al <span style={{ color: '#ff0f64', fontWeight: '500' }}>{date}</span>
                                            </Typography>
                                            <Tooltip enterTouchDelay={0} title={<p style={{ fontSize: '14px', padding: '5px' }}>L'aggiornamento viene effettuato una volta a settimana.</p>}>
                                                <img src={Info} alt='info' style={{ width: '18px', height: '18px', marginLeft: '6px', userSelect: 'none', cursor: 'pointer' }} />
                                            </Tooltip>
                                        </Box>
                                    </Box>
                                </Box>
                            </Paper>
                        </Box>
                        {/* Descrizione */}
                        <Box sx={{ width: '100%', maxWidth: '460px', display: 'flex' }}>
                            <Paper
                                elevation={0}
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    p: { xs: 3, sm: 4 },
                                    borderRadius: '24px',
                                    boxShadow: '0 16px 40px rgba(0,0,0,0.07)',
                                    backgroundColor: 'white',
                                    boxSizing: 'border-box',
                                }}
                            >
                                <Typography variant="h4" component="h2" sx={{ fontSize: { xs: '1.75rem', md: '2rem' }, fontWeight: 700, color: '#2c3e50', mb: 1.5, lineHeight: 1.3 }}>
                                    Verifica la tua connessione.
                                </Typography>
                                <Typography variant="body1" sx={{ color: 'text.secondary', fontSize: '0.95rem', lineHeight: 1.6, mb: 2 }}>
                                    Inserisci il tuo indirizzo per scoprire quali tecnologie e operatori sono disponibili nella tua zona.
                                </Typography>
                                <List sx={{ width: '100%', bgcolor: 'transparent', flexGrow: 1, display: 'flex', flexDirection: 'column', gap: 1.5, justifyContent: 'space-between', p: 0 }}>
                                    <ListItem alignItems="flex-start" sx={{ p: 0 }}>
                                        <ListItemIcon sx={{ minWidth: '40px' }}>
                                            <SpeedIcon sx={{ color: '#ff0f64', fontSize: 28, mt: 0.5 }} />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={<Typography sx={{ fontWeight: 'bold', color: '#2c3e50', fontSize: '0.95rem' }}>Tecnologie FTTH e FTTC</Typography>}
                                            secondary={
                                                <Typography component="span" variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                                                    Controlla la disponibilità di connessioni <strong style={{ color: '#ff0f64' }}>FTTH</strong> (fibra fino a casa) e <strong style={{ color: '#ff0f64' }}>FTTC</strong> (fibra fino all'armadio).
                                                </Typography>
                                            }
                                        />
                                    </ListItem>
                                    <ListItem alignItems="flex-start" sx={{ p: 0 }}>
                                        <ListItemIcon sx={{ minWidth: '40px' }}>
                                            <LanIcon sx={{ color: '#ff0f64', fontSize: 28, mt: 0.5 }} />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={<Typography sx={{ fontWeight: 'bold', color: '#2c3e50', fontSize: '0.95rem' }}>Principali Reti Nazionali</Typography>}
                                            secondary={
                                                <Typography component="span" variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                                                    Verifica la copertura delle reti <strong style={{ color: '#2c3e50' }}>FiberCop</strong> e <strong style={{ color: '#2c3e50' }}>Open Fiber</strong>, i maggiori operatori di rete in Italia.
                                                </Typography>
                                            }
                                        />
                                    </ListItem>
                                    <ListItem alignItems="flex-start" sx={{ p: 0 }}>
                                        <ListItemIcon sx={{ minWidth: '40px' }}>
                                            <CheckCircleOutlineIcon sx={{ color: '#ff0f64', fontSize: 28, mt: 0.5 }} />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={<Typography sx={{ fontWeight: 'bold', color: '#2c3e50', fontSize: '0.95rem' }}>Risultati Dettagliati</Typography>}
                                            secondary={
                                                <Typography component="span" variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                                                    Ottieni informazioni precise e aggiornate per trovare l'offerta migliore per le tue esigenze.
                                                </Typography>
                                            }
                                        />
                                    </ListItem>
                                </List>
                            </Paper>
                        </Box>
                    </Box>
                </Container>
            </Box>
            <Box sx={{ backgroundColor: '#f9fafb', py: { xs: 4, sm: 6, md: 8 } }}>
                <Typography variant="h3" sx={{ color: '#2c3e50', fontWeight: '700', mb: 6, textAlign: 'center' }}>
                    Dal Nostro Blog
                </Typography>
                <Container maxWidth="xl">
                    {postsLoading ? (
                        <Grid container spacing={4} justifyContent="flex-start" alignItems="stretch">
                            {Array.from(new Array(6)).map((item, index) => (
                                /* Centra lo skeleton rigido all'interno del suo spazio di colonna */
                                <Grid item xs={4} key={index} sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <StyledCard sx={{ width: '400px', height: '550px', display: 'flex', flexDirection: 'column' }}>
                                        <Skeleton variant="rectangular" animation="wave" height={250} />
                                        <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', p: 3 }}>
                                            <Skeleton animation="wave" height={15} width="40%" sx={{ mb: 1.5 }} />
                                            <Skeleton animation="wave" variant="text" sx={{ fontSize: '1.5rem', mb: 2 }} />
                                            <Skeleton animation="wave" variant="rectangular" height={60} sx={{ mb: 3, flexGrow: 1 }} />
                                            <Skeleton animation="wave" height={24} width="30%" />
                                        </CardContent>
                                    </StyledCard>
                                </Grid>
                            ))}
                        </Grid>
                    ) : (
                        <Grid
                            container
                            spacing={4}
                            sx={{
                                justifyContent: 'center'
                            }}
                        >
                            {latestPosts.map(post => (
                                /* CENTRA LA CARD ALL'INTERNO DEL 33.33% DI SPAZIO ASSEGNATO */
                                <Grid item xs={4} key={post.id} sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <StyledCard sx={{ width: '450px', minHeight: '400px', display: 'flex', flexDirection: 'column' }}>
                                        {post.cover_image && (
                                            <CardMedia component="img" height="250" image={post.cover_image} alt={post.title} />
                                        )}
                                        <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', p: 3 }}>
                                            <Typography variant="caption" sx={{ color: 'text.secondary', mb: 1.5, display: 'block' }}>
                                                {new Date(post.published_at || post.created_at).toLocaleDateString('it-IT', { year: 'numeric', month: 'long', day: 'numeric' })}
                                            </Typography>
                                            <Typography variant="h5" component="h2" sx={{ fontWeight: '700', mb: 2, flexGrow: 1 }}>
                                                <Link to={`/blog/${post.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                                    {post.title}
                                                </Link>
                                            </Typography>
                                            <Box sx={{ mt: 'auto', pt: 2 }}>
                                                <ButtonMui component={Link} to={`/blog/${post.slug}`} variant="text" sx={{ color: '#ff0f64', fontWeight: 'bold', p: 0, '&:hover': { backgroundColor: 'transparent', color: '#d00b52' } }}>
                                                    Leggi l'articolo
                                                </ButtonMui>
                                            </Box>
                                        </CardContent>
                                    </StyledCard>
                                </Grid>
                            ))}
                        </Grid>
                    )}
                    <Box sx={{ textAlign: 'center', mt: 6 }}>
                        <ButtonMui component={Link} to="/blog" variant="contained" sx={{ backgroundColor: '#ff0f64', borderRadius: '30px', px: 5, py: 1.5, textTransform: 'none', fontSize: '1.1rem', fontWeight: 'bold', boxShadow: '0 4px 14px rgba(255,15,100,0.3)', '&:hover': { backgroundColor: '#d00b52' } }}>
                            Vedi tutti gli articoli
                        </ButtonMui>
                    </Box>
                </Container>
            </Box>
        </div>

    )
}

export default Home;